
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../controlador';

    import inicio from './inicio/estadisticas-inicio.vue';

    import clientes from './clientes/estadisticas-clientes.vue';
    import predefinidas from './predefinidas/preguntas-predefinidas.vue';
    import cliente from './cliente/estadisticas-cliente.vue';


    import toolbar from './estadisticas-toolbar.vue';
    import a_menu from './estadisticas-menu-a.vue';
    import b_menu from './estadisticas-menu-b.vue';
import router from '@/__env/router.index';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            toolbar,
            a_menu,
            b_menu,

            inicio,
            predefinidas,

            clientes,
            cliente,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public MenuAbierto: boolean = false;
        public Buscador: string = '';
        public Estado: string = '';
        public SubModo: string = '';
        public Modo: string = '';

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            this.Buscador = this.Controlador.Vista.Buscador;
            this.Estado = this.Controlador.Vista.Estado;
            this.Modo = this.Controlador.Vista.Modo;
            this.Eventos.push( this.Controlador.Vista.onBuscador.subscribe( () => this.Buscador = this.Controlador.Vista.Buscador ) );
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () => this.Estado = this.Controlador.Vista.Estado ) );
            this.Eventos.push( this.Controlador.Vista.onModo.subscribe( () => this.Modo = this.Controlador.Vista.Modo ) );
            this.Eventos.push( this.Controlador.Vista.onSubModo.subscribe( () => this.SubModo = this.Controlador.Vista.SubModo ) );
            this.Eventos.push( this.Controlador.Vista.onMenuAbierto.subscribe( () => this.MenuAbierto = this.Controlador.Vista.MenuAbierto ) );

            window.addEventListener( 'popstate', this.Atras, false );

        }

        async Atras( e: any )
        {
            await this.Controlador.Vista.Atras();

        }
    }
